import menu from "./en/menu.json";
import banner from "./en/banner.json";
import profiles from "./en/profiles.json";
import employees from "./en/employees.json";
import pages from "./en/pages.json";
import gallery from "./en/gallery.json";
import documents from "./en/documents.json";
import priceList from "./en/pricelist.json";
import notifications from "./en/notifications.json";
import articles from "./en/articles.json";
import events from "./en/events.json";
import products from "./en/products.json";
import orders from "./en/orders.json";
import vacancies from "./en/vacancies.json";
import profile from "./en/profile.json";
import privileges from "./en/privileges.json";
import settings from "./en/settings.json";
import login from "./en/login.json";
import dashboard from "./en/dashboard.json";
import errors from "./en/errors.json";

import common from "./en/common.json";

import categoriesComponent from "./en/components/categories.json";
import itemsControllerComponent from "./en/components/items-controller.json";
import imageInputComponent from "./en/components/image-input.json";

export const EN = {
	menu: menu,
	banner: banner,
	profiles: profiles,
	employees: employees,
	pages: pages,
	gallery: gallery,
	documents: documents,
	priceList: priceList,
	notifications: notifications,
	articles: articles,
	events: events,
	products: products,
	orders: orders,
	vacancies: vacancies,
	profile: profile,
	privileges: privileges,
	settings: settings,
	login: login,
	dashboard: dashboard,
	errors: errors,
	common: common,
	categoriesC: categoriesComponent,
	itemsControllerC: itemsControllerComponent,
	imageInputC: imageInputComponent,
};
